module.exports = __webpack_public_path__ + "img/canbadge-round-32mm-2.0-credit_trimmark.bf84e0ec.png";